export class AppAnalytics {
  custId: string;
  employeeId: string;
  childSequenceId?: string;
  transactionId: string;
  transactionType: TransactionTypes;
  metaData?: MetaData[];
  constructor(obj?: any) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}

export class MetaData {
  key: string;
  value: string;
}

export enum TransactionTypes {
  WorkOrder = 'WO',
  ServiceAppointment = 'SA',
  ServiceQuote = 'QO',
}
